<div class="preview" data-testid="MoviePlayerPage.previewProgress" @animation>
  <ng-container *ngIf="vm.content | contentExtendedData | async as extendedContentData; else shimmerLoading">
    <ng-container *ngIf="extendedContentData.bookmark as playbackInfo; else shimmerLoading">
      <div class="preview-thumbnail">
        <!-- TODO {MO}: GTM -->
        <a
          osnSharedAspectRatio="16:9"
          osnSharedPreviewOverlayGtm
          [vm]="vm"
          [lengthInSeconds]="playbackInfo.contentLength"
          [routerLink]="extendedContentData.routerLink"
          [state]="navigationState"
        >
          <img
            class="thumbnail"
            osnSharedUseAsPicture
            [src]="extendedContentData.landscapeImageUrl ?? 'assets/images/placeholder/contentLandscape.png'"
            [alt]="vm.title"
            [imgQuery]="vm.imgQuery"
          />
        </a>

        <div class="gradient-layer"></div>
        <div class="row-start-start button-row">
          <div class="d-none d-lg-block">
            <ng-container
              *ngTemplateOutlet="
                playButton;
                context: {
                  tooltip:
                    (playbackInfo.hasProgress ? 'PreviewOverlay_Tooltip_Resume' : 'PreviewOverlay_Tooltip_Play')
                    | watchFreeTrial
                    | translate,
                  buttonText:
                    vm.type
                    | playButtonText: playbackInfo.hasProgress:playbackInfo.seasonNumber:playbackInfo.episodeNumber
                    | watchFreeTrial
                    | translate
                }
              "
            ></ng-container>
          </div>

          <div class="d-lg-none">
            <ng-container
              *ngTemplateOutlet="
                playButton;
                context: {
                  tooltip:
                    (playbackInfo.hasProgress ? 'PreviewOverlay_Tooltip_Resume' : 'PreviewOverlay_Tooltip_Play')
                    | watchFreeTrial
                    | translate
                }
              "
            ></ng-container>
          </div>

          <ng-template #playButton let-tooltip="tooltip" let-buttonText="buttonText">
            <div
              [matTooltip]="
                (playbackInfo.hasProgress ? 'PreviewOverlay_Tooltip_Resume' : 'PreviewOverlay_Tooltip_Play') | watchFreeTrial | translate
              "
              matTooltipClass="custom-tooltip hide-on-large-screens"
            >
              <!-- TODO {MO}: GTM -->
              <osn-shared-icon-button
                [previewButton]="true"
                [iconName]="'play'"
                [buttonText]="buttonText"
                [buttonTextForGA]="playbackInfo.hasProgress ? 'Resume' : 'Play'"
                [showLoadingIndicator]="shouldShowPlayButtonSpinner$ | async"
                osnPlay
                [movieOrSeriesTitle]="extendedContentData.title | currentLocale"
                [guid]="vm.guid"
                osnSharedPreviewOverlayGtm
                [vm]="vm"
                [hideIcon]="true"
                [lengthInSeconds]="playbackInfo.contentLength"
                data-testid="HomePage.previewOverlayPlayIcon"
              >
              </osn-shared-icon-button>
            </div>
          </ng-template>

          <osn-shared-icon-button
            [previewButton]="true"
            *ngIf="extendedContentData.hasTrailer && !extendedContentData.hasMedia"
            [iconName]="'play'"
            buttonTextForGA="Play trailer"
            [buttonText]="'PreviewOverlay_Tooltip_Trailer' | translate | uppercase"
            [guid]="vm.guid"
            [isTrailer]="true"
            osnPlay
            [matTooltip]="'PreviewOverlay_Tooltip_Trailer' | translate"
            matTooltipClass="custom-tooltip hide-on-large-screens"
            data-testid="HomePage.previewOverlayTrailerIcon"
          ></osn-shared-icon-button>

          <!-- buttonText and icon is set in the directive in case of My List buttons -->
          <osn-shared-icon-button
            [previewButton]="true"
            [type]="'secondary'"
            #myListButton="osnMyList"
            osnMyList
            [reflectStateInIconText]="false"
            [programAvailabilityIdUrl]="vm.content.id"
            [title]="vm.title | currentLocale"
            [content]="vm.content"
            [buttonTextForGA]="(myListButton.isAddedToWatchlist$ | async) ? 'Remove from MyList' : 'Add to MyList'"
            [itemGuid]="vm.guid"
            [matTooltip]="
              ((myListButton.isAddedToWatchlist$ | async)
                ? 'PreviewOverlay_Tooltip_RemoveFromMyList'
                : 'PreviewOverlay_Tooltip_AddToMyList'
              ) | translate
            "
            matTooltipClass="custom-tooltip"
            osnSharedPreviewOverlayGtm
            [vm]="vm"
            [lengthInSeconds]="playbackInfo.contentLength"
            data-testid="HomePage.previewOverlayMyListIcon"
          >
          </osn-shared-icon-button>

          <a
            *ngIf="extendedContentData.routerLink"
            [routerLink]="extendedContentData.routerLink"
            [matTooltip]="'PreviewOverlay_Tooltip_MoreInfo' | translate"
            matTooltipClass="custom-tooltip"
          >
            <!-- TODO {MO}: GTM -->
            <osn-shared-icon-button
              [previewButton]="true"
              [type]="'secondary'"
              [iconName]="'more-info'"
              osnSharedPreviewOverlayGtm
              [vm]="vm"
              buttonTextForGA="More info"
              [lengthInSeconds]="playbackInfo.contentLength"
              data-testid="HomePage.previewOverlayMoreInfoIcon"
            ></osn-shared-icon-button>
          </a>
        </div>
      </div>

      <div class="content">
        <div class="progress-info d-flex" *ngIf="playbackInfo.hasProgress">
          <osn-shared-progress-bar
            class="flex-grow-1"
            *ngIf="playbackInfo.hasProgress"
            [showProgressMinutes]="true"
            [lengthInSeconds]="playbackInfo.contentLength"
            [elapsedInSeconds]="playbackInfo.bookmarkTime"
          ></osn-shared-progress-bar>
        </div>

        <ng-container *ngIf="!playbackInfo.hasProgress">
          <div class="details-container">
            <span *ngIf="vm.type === 'season'" class="d-flex season-info">
              <span class="season-info-title">{{ vm.title }}</span>
              <span class="season-info-season">{{ 'PreviewOverlay_SeasonNumber' | translate: { season: playbackInfo.seasonNumber } }}</span>
            </span>

            <osn-shared-short-details
              [size]="'normal'"
              [lengthInSeconds]="playbackInfo.contentLength"
              [numberOfSeasons]="extendedContentData.numberOfSeasons"
              [numberOfEpisodes]="extendedContentData.numberOfSeasons"
              [releaseYear]="extendedContentData.releaseYear"
              [ageRate]="extendedContentData.ageRate"
              [darkTextColor]="true"
              [showLength]="vm.type === 'movie'"
            ></osn-shared-short-details>

            <osn-shared-genre-list
              [genres]="extendedContentData.genres"
              [darkTextColor]="true"
              (genreClickEvent)="onGenreClick($event)"
            ></osn-shared-genre-list>
            <ng-container *ngIf="(extendedContentData.description | currentLocale)?.length">
              <div
                class="description-container"
                [@expandAnimation]="isDescriptionOpen ? 'open' : 'close'"
                [class.closed]="!isDescriptionOpen"
              >
                <p class="content-description">{{ extendedContentData.description | currentLocale }}</p>
                <div class="description-gradient"></div>
              </div>
              <div
                class="description-toggle d-flex justify-content-center"
                (click)="toggleDescription()"
                [class.opened]="isDescriptionOpen"
              >
                <svg-icon key="down"></svg-icon>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #shimmerLoading>
  <div class="shimmer-loading-parent">
    <osn-shared-shimmer-loading [useDynamicFullSize]="true"></osn-shared-shimmer-loading>
  </div>
</ng-template>
